import { useState } from 'react';
import DatePicker from '@rio-cloud/rio-uikit/DatePicker';

import BackButton from '../components/BackButton';
import { DEFAULT_ROUTE } from '../routes/routes';
import moment, { Moment } from 'moment';

interface CarrierReport {
    carrier_name: String;
    carrier_account_id: String;
    number_of_transport_orders: Number;
    number_of_transport_orders_with_confirmations: Number;
    number_of_transport_orders_with_confirmations_with_means_of_transport: Number;
}

interface ShipperReport {
    shipper_id: String;
    number_of_transport_orders: Number;
    number_of_transport_orders_with_confirmations: Number;
    number_of_transport_orders_with_confirmations_with_means_of_transport: Number;
}

interface TransportOrderReport {
    id: String;
    bundle_id: String;
    external_id: String;
    external_consignment_reference_number?: String;
    contractor: String;
    contractor_account_id?: String;
    shipper: String;
    shipper_id: String;
    means_of_transport?: String;
    has_internal_place_of_destination: Boolean;
    is_confirmed: Boolean;
    is_cancelled: Boolean;
}

interface Reports {
    carrier_reports: CarrierReport[];
    shipper_reports: ShipperReport[];
    transport_order_reports: TransportOrderReport[];
}

const CarrierCompliance = () => {
    const [from, setFrom] = useState<String | undefined>();
    const [to, setTo] = useState<String | undefined>();
    const [reports, setReports] = useState<unknown | undefined>();

    const tryFetchReport = async () => {
        if (from && to) {
            const reports = await (
                await fetch(
                    `https://carrier-reporting-service.transport-order-exchange.rio.cloud/reports?from=${from}&to=${to}`
                )
            ).json();
            setReports(reports);
            console.log(reports);
        }
    };

    const handleFromChange = (value: string | Moment) => {
        const isoString = moment.isMoment(value) ? value.toISOString() : moment(value).toISOString();

        setFrom(isoString);
        tryFetchReport();
    };
    const handleToChange = (value: string | Moment) => {
        const isoString = moment.isMoment(value) ? value.toISOString() : moment(value).toISOString();

        setTo(isoString);
        tryFetchReport();
    };

    return (
        <div className='carrier-compliance'>
            <BackButton href={`#${DEFAULT_ROUTE}`} />
            <div className='text-size-h2 margin-bottom-15 margin-top-10 text-medium text-uppercase'>
                Carrier Compliance
            </div>
            <div className='display-flex gap-10 max-width-400 margin-bottom-10'>
                <div className='flex-1-1-0'>
                    <label htmlFor='from'>From:</label>
                    <DatePicker
                        id='from'
                        inputProps={{ placeholder: 'Select Date' }}
                        timeFormat={false}
                        clearableInput
                        onChange={handleFromChange}
                    />
                </div>
                <div className='flex-1-1-0'>
                    <label htmlFor='to'>To:</label>
                    <DatePicker
                        id='to'
                        inputProps={{ placeholder: 'Select Date' }}
                        timeFormat={false}
                        clearableInput
                        alignRight
                        onChange={handleToChange}
                    />
                </div>
            </div>
            <table>
                <thead>
                    <tr>
                        <th className='user-select-none sort-column' title=''>
                            Carrier Name
                        </th>
                        <th className='user-select-none sort-column' title=''>
                            Carrier Account ID
                        </th>
                        <th className='user-select-none sort-column' title=''>
                            # Orders
                        </th>
                        <th className='user-select-none sort-column' title=''>
                            # Confirmed Orders
                        </th>
                        <th className='user-select-none sort-column' title=''>
                            # Confirmed Orders With Vehicle
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {reports?.carrier_reports.map(carrierReport => (
                        <tr>
                            <td data-value={carrierReport.carrier_name}>{carrierReport.carrier_name}</td>
                            <td data-value={carrierReport.carrier_account_id}>{carrierReport.carrier_account_id}</td>
                            <td
                                data-value={carrierReport.number_of_transport_orders}
                            >{`${carrierReport.number_of_transport_orders}`}</td>
                            <td
                                data-value={carrierReport.number_of_transport_orders_with_confirmations}
                            >{`${carrierReport.number_of_transport_orders_with_confirmations}`}</td>
                            <td
                                data-value={
                                    carrierReport.number_of_transport_orders_with_confirmations_with_means_of_transport
                                }
                            >{`${carrierReport.number_of_transport_orders_with_confirmations_with_means_of_transport}`}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
export default CarrierCompliance;
